module.exports = __webpack_public_path__ + "img/kernelback5.45c6e46d.png";